import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import Loader from '@/components/common/Loader';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import useDefaultBoard from '../../lib/hooks/useDefaultBoard';
import useLifecycleBoards from '../../lib/hooks/useLifecycleBoards';
import EmptyListView from './EmptyListView';

function LifecycleBoardListView() {
  const { data: board, error } = useDefaultBoard({
    revalidateIfStale: true,
    shouldRetryOnError: false,
  });
  const { data: boards } = useLifecycleBoards();
  const history = useHistory();

  // TODO(jon): Eventually this will be a normal list view page showing the
  // available lifecycle boards. However, that doesn't exist yet. We want to
  // redirect users to their default board. If they have no default board
  // because they've deleted all their boards, we want to show them the
  // `EmptyListView`.
  //
  // Where this gets tricky is in caching, both on the front and back end. The
  // endpoint for `useLifecycleBoards` is on Elastic Search and has a bit of a
  // delay in reflecting the list of boards when you delete a board.
  // `useDefaultBoard` uses that Elastic Search result and picks the first one
  // off the list to make a Dynamo DB request for the individual record. Here is
  // where we might see a 404 `error` because the search results can lead us to
  // request a board that no longer exists. If that happens, that's fine, we
  // just show the `EmptyListView`.
  //
  // Sounds complicated and it kind of is, but when the proper ListView feature
  // gets built out this will all go away as we will just show a list of boards
  // or an empty state with no worries about redirects and feature flags and
  // caching.
  React.useEffect(() => {
    if (!board || !boards?.length || error) return;
    history.replace(generatePath(AuthRoutes.BOARD, { boardId: board.boardId }));
  }, [board, boards, error]);

  if (error || (boards && !boards.length)) {
    return <EmptyListView />;
  }

  return (
    <div className="flex h-full w-full items-center justify-center">
      <Loader />
    </div>
  );
}

export default LifecycleBoardListView;
